import axios from 'axios';
import HttpHelper from '../helper/HttpHelper';

class VendorService {

    getAll(payload) {
        return axios.get(HttpHelper.API_URL + '/vendors', { params: payload }, HttpHelper.getHeader());
    }

    getVendor(id, payload) {
        return axios.get(HttpHelper.API_URL + '/vendors/' + id, { params: payload }, HttpHelper.getHeader());
    }

    create(payload) {
        return axios.post(HttpHelper.API_URL + '/vendors', payload, HttpHelper.getAuthHeader());
    }

    update(id, payload) {
        return axios.put(HttpHelper.API_URL + "/vendors/" + id, payload, HttpHelper.getAuthHeader());
    }

    delete(id) {
        return axios.delete(HttpHelper.API_URL + "/vendors/" + id, HttpHelper.getAuthHeader());
    }

}

export default new VendorService();